<template>
  <div class="nebFormControl"
    :style="{
      width
    }"
  >
    <div class="nebFormControl-label"
      v-if="label"
    >
      <label>
        {{ label }}
      </label>

      <div class="nebFormControl-info"
        v-if="infoText !== ''"
      >
        <neb-tooltip :content="infoText"
          :position="tooltipPosition"
        >
          <neb-icon name="info"
            width="10px"
            height="10px"
          ></neb-icon>
        </neb-tooltip>
      </div>
      <div class="nebFormControl-required"
        v-if="required"
      >*</div>
    </div>

    <div class="nebFormControl-content">
      <div class="nebFormControl-content-wrapper"
        :class="[ align ]"
      >
        <slot></slot>
      </div>

      <div class="nebFormControl-error"
        v-show="errorText !== ''"
      >
        <neb-icon name="x"
          width="12px"
          height="12px"
        ></neb-icon>

        <p>{{ errorText }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import NebIcon from '../../Icon'
import NebTooltip from '../../generic/Tooltip'

export default {
  name: 'NebFormControl',

  components: {
    NebIcon,
    NebTooltip
  },

  props: {
    label: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    infoText: {
      type: String,
      default: ''
    },
    errorText: {
      type: String,
      default: ''
    },
    tooltipPosition: {
      type: String,
      default: 'top'
    },
    width: {
      type: String,
      default: 'auto'
    },
    align: {
      type: String,
      default: 'start'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../style.scss';

.nebFormControl {
  margin-bottom: 15px;

  &-content {
    &-wrapper {
      display: flex;

      &.end {
        justify-content: flex-end;
      }
    }
  }

  &-label {
    padding-bottom: 5px;
    line-height: 12px;

    label {
      font-size: 12px;
      color: $slate-grey;
      font-family: "Helvetica Neue";
      font-weight: 500;
    }
  }

  &-required {
    color: $blush;
    line-height: 12px;
    height: 7px;
    font-size: 18px;
    vertical-align: middle;
    display: inline-block;
  }

  &-info {
    display: inline-block;
    height: 12px;
    box-sizing: border-box;
    overflow: hidden;
    vertical-align: middle;
    line-height: 10px;
    padding-left: 3px;

    .nebIcon {
      color: $warm-grey;
    }
  }

  &-error {
    padding: 5px 0 0 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    span {
      display: block;
    }

    p {
      padding-left: 5px;
      margin: 0;
      color: $blush;
      font-size: 12px;
      font-family: $defaultFont;
      display: block;
    }

    .nebIcon {
      color: $blush;
    }
  }
}
</style>
